import { capitalizeString } from '@strata/helper-functions';
import { ActionButtonText } from '@strata/react-buttons';
import { useState } from 'react';

import { List } from 'components/List';
import { SupplierConsolidationDialog } from 'pages/npiManagement/dialogs/SupplierConsolidationDialog';
import { useGetWithRefetch } from 'services/Http';

const columns = ['NPI', 'Organization Name', 'Network Status', 'Supplier Locations'];
const columnWidths = [120, 250, 140, 800];

export const SupplierList = () => {
    const [isConsolidationDialogOpen, setIsConsolidationDialogOpen] = useState(false);
    const { result: suppliers, refetch: refetchSuppliers } =
        useGetWithRefetch('/reference/suppliers/');

    const parentSuppliers = suppliers?.filter((s) => s.parent_supplier_npi == null);
    const childSuppliers = suppliers?.filter((s) => s.parent_supplier_npi != null);

    // Create a map of parents to children
    const parentChildMap = {};
    childSuppliers?.forEach((child) => {
        if (!parentChildMap[child.parent_supplier_npi]) {
            parentChildMap[child.parent_supplier_npi] = [];
        }
        parentChildMap[child.parent_supplier_npi].push(child);
    });

    return (
        <>
            <List
                pageTitle="Suppliers"
                columnNames={columns}
                columnWidths={columnWidths}
                isLoading={!suppliers}
                listData={parentSuppliers?.map((s) => [
                    s.supplier_npi,
                    s.organization_name,
                    capitalizeString(s.network_status),
                    (parentChildMap[s.supplier_npi] ?? [])
                        .map((child) => `(${child.supplier_npi}, ${child.organization_name})`)
                        .join(', '),
                ])}
                createPath="/create-supplier"
                editPath="/edit-supplier"
                createButtonLabel="Add Supplier"
                rightContent={
                    <ActionButtonText
                        label="Consolidate Suppliers"
                        disabled={!suppliers}
                        onClick={() => setIsConsolidationDialogOpen(true)}
                    />
                }
            />
            <SupplierConsolidationDialog
                isOpen={isConsolidationDialogOpen}
                suppliers={suppliers ?? []}
                onClose={() => setIsConsolidationDialogOpen(false)}
                onConsolidated={refetchSuppliers}
            />
        </>
    );
};
